

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import NumberPicker from '@/modules/shared/components/number-picker.component.vue';

import RewardExchangeLine from '@/modules/loyalty/model/reward-exchange-line.model';

import pluralizeFilter from '@/modules/shared/filters/pluralize.filter';
import number from '@/modules/shared/filters/number.filter.ts';


@Component({
    components: {
        NumberPicker,
    },
    computed: {
        ...mapGetters({
            getRewardCartLine: 'getRewardCartLine',
            currentPoints: 'getRewardCartLineCurrentPoints',
            remainingPoints: 'getRemainingPoints',
        }),
    },
    filters: {
        pluralizeFilter,
        number,
    },
})
export default class RewardCartLine extends Vue {
    @Prop() private lineId!: string;


    private getRewardCartLine!: any;
    private currentPoints!: any;
    private remainingPoints!: any;
    private literals =  {
        point: 'punto',
        points: 'puntos',
    };


    get line() {
        return this.getRewardCartLine(this.lineId);
    }

    get lineCurrentPoint() {
        return this.currentPoints(this.lineId);
    }

    get quantity() {
        return this.line.quantity || 0;
    }
    set quantity(value: number) {
        if ( this.line && value !== this.line.quantity) {
            this.$store.commit('setQuantityRewardCartLine', {
                id: this.lineId,
                quantity: value,
            });
        }
    }

    get hasEnoughPoints() {
        return this.line.requiredPoints <= this.remainingPoints;
    }


    private removeLine() {
        this.$emit('remove-cart-line', this.lineId);
    }
}

